import { defineMessages } from 'react-intl';

export default defineMessages({
    SptExpiredSingleTripHeader: {
        id: 'qnb.sptExpiredSingleTripModal.Header',
        defaultMessage: 'Has your departure date changed?'
    },
    SptExpiredSingleTripParagraph1: {
        id: 'qnb.sptExpiredSingleTripModal.Paragraph1',
        defaultMessage: 'Your quote\'s original departure date has passed.'
    },
    SptExpiredSingleTripParagraph2: {
        id: 'qnb.sptExpiredSingleTripModal.Paragraph2',
        defaultMessage: 'Just click \'Continue\' and provide a new departure date.'
    },
    SptExpiredSingleTripContinue: {
        id: 'qnb.sptExpiredSingleTripModal.Continue',
        defaultMessage: 'Continue'
    }
});
